import { useNuxtApp } from "#imports";

export function useSentry() {
  return useNuxtApp().$sentry;
}
